import { render, staticRenderFns } from "./quotationProcessCost-tab.vue?vue&type=template&id=04062994"
import script from "./quotationProcessCost-tab.vue?vue&type=script&lang=js"
export * from "./quotationProcessCost-tab.vue?vue&type=script&lang=js"
import style0 from "./quotationProcessCost-tab.vue?vue&type=style&index=0&id=04062994&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports